var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_2727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 7.2001C13.2 9.18832 11.5882 10.8001 9.59999 10.8001C7.61177 10.8001 5.99999 9.18832 5.99999 7.2001C5.99999 5.21188 7.61177 3.6001 9.59999 3.6001C11.5882 3.6001 13.2 5.21188 13.2 7.2001ZM18 7.2001C18.6628 7.2001 19.2 7.73736 19.2 8.4001V9.6001H20.4C21.0628 9.6001 21.6 10.1374 21.6 10.8001C21.6 11.4628 21.0628 12.0001 20.4 12.0001H19.2V13.2001C19.2 13.8628 18.6628 14.4001 18 14.4001C17.3372 14.4001 16.8 13.8628 16.8 13.2001V12.0001H15.6C14.9372 12.0001 14.4 11.4628 14.4 10.8001C14.4 10.1373 14.9372 9.6001 15.6 9.6001H16.8V8.4001C16.8 7.73736 17.3372 7.2001 18 7.2001ZM16.8 20.4001C16.8 16.4237 13.5764 13.2001 9.59999 13.2001C5.62354 13.2001 2.39999 16.4237 2.39999 20.4001H16.8Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUserPlus);
export default __webpack_public_path__ + "static/media/u_user-plus.42af2baaa74d320fc201a022d8e9379d.svg";
export { ForwardRef as ReactComponent };